const defaultState = {
  categories: [],
  data: [],
  loading: false,
  error: false,
};

const siteNotes = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case 'SET_SITE_NOTE_CATEGORIES':
      return { ...state, categories: action.data };

    case 'SET_SITE_NOTES':
      return { ...state, data: action.data };

    case 'SET_SITE_NOTES_LOADING':
      return {
        ...state,
        loading: action.data,
      };

    case 'SET_SITE_NOTES_ERROR':
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default siteNotes;
